export default __webpack_public_path__ + "static/favicon-5240f237a9e996c1b5d21f3a0c2135e1.png";